import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default {
  modal: redukers.value({
    set: [
      actionTypes.OPEN_ADD_VENDOR_MODAL,
      actionTypes.OPEN_RESEND_INVITATION_MODAL,
      actionTypes.OPEN_SAVE_NEW_SEARCH_MODAL,
    ],
    reset: actionTypes.CLOSE_MODAL,
  }),
}
